import { render } from "./RezepteNeuView.vue?vue&type=template&id=00a4769d&scoped=true"
import script from "./RezepteNeuView.vue?vue&type=script&lang=js"
export * from "./RezepteNeuView.vue?vue&type=script&lang=js"

import "./RezepteNeuView.vue?vue&type=style&index=0&id=00a4769d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a4769d"]])

export default __exports__